// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Webapi__Dom__Node = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Node.bs.js");
var Webapi__Dom__Element = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Element.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");

function t_encode(v) {
  if (typeof v === "number") {
    if (v === /* Ignored */0) {
      return ["Ignored"];
    } else {
      return ["NoInnerText"];
    }
  } else if (v.TAG === /* FullInnerText */0) {
    return [
            "FullInnerText",
            Decco.stringToJson(v._0)
          ];
  } else {
    return [
            "TruncatedInnerText",
            Decco.stringToJson(v._0),
            Decco.intToJson(v._1)
          ];
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "FullInnerText" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FullInnerText */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Ignored" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Ignored */0
                  };
          }
      case "NoInnerText" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NoInnerText */1
                  };
          }
      case "TruncatedInnerText" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* TruncatedInnerText */1,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$1 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(v) {
  if (typeof v === "number") {
    if (v === /* Ignored */0) {
      return "Ignored";
    } else {
      return "NoInnerText";
    }
  } else if (v.TAG === /* FullInnerText */0) {
    return "FullInnerText(" + (v._0 + ")");
  } else {
    return "TruncatedInnerText(" + (v._0 + (String(v._1) + ")"));
  }
}

function fromString(s) {
  var s$1 = s.trim();
  if (s$1 === "") {
    return /* NoInnerText */1;
  } else {
    return {
            TAG: /* FullInnerText */0,
            _0: s$1
          };
  }
}

function equals(innerTextA, innerTextB) {
  if (typeof innerTextA === "number") {
    if (innerTextA === /* Ignored */0) {
      return innerTextB === 0;
    } else if (typeof innerTextB === "number") {
      return innerTextB !== 0;
    } else {
      return false;
    }
  } else if (innerTextA.TAG === /* FullInnerText */0) {
    if (typeof innerTextB === "number" || innerTextB.TAG !== /* FullInnerText */0) {
      return false;
    } else {
      return innerTextA._0 === innerTextB._0;
    }
  } else if (typeof innerTextB === "number" || !(innerTextB.TAG === /* TruncatedInnerText */1 && innerTextA._0 === innerTextB._0)) {
    return false;
  } else {
    return innerTextA._1 === innerTextB._1;
  }
}

var InnerText = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify,
  fromString: fromString,
  equals: equals
};

function makeNode(id, tagName, classNames, attributes, innerText, clientLeft, clientTop, clientWidth, clientHeight, element) {
  var tmp;
  if (id !== undefined) {
    switch (id) {
      case "" :
      case "undefined" :
          tmp = undefined;
          break;
      default:
        tmp = id;
    }
  } else {
    tmp = id;
  }
  var tmp$1;
  tmp$1 = innerText !== undefined && !(innerText === "undefined" || innerText.trim() === "") ? ({
        TAG: /* FullInnerText */0,
        _0: innerText
      }) : /* NoInnerText */1;
  return {
          TAG: /* ElementNode */1,
          _0: {
            id: tmp,
            tagName: OptionUtils$SmartcutsMacros.$neg$question$great(tagName, (function (prim) {
                    return prim.toLowerCase();
                  })),
            classNames: classNames !== undefined ? classNames : [],
            attributes: attributes !== undefined ? attributes.filter(function (param) {
                    switch (param[0]) {
                      case "class" :
                      case "id" :
                      case "style" :
                          return false;
                      default:
                        return true;
                    }
                  }) : [],
            innerText: tmp$1,
            shape: clientWidth !== undefined && clientHeight !== undefined ? ({
                  clientWidth: clientWidth,
                  clientHeight: clientHeight
                }) : undefined,
            offsetPosition: clientLeft !== undefined && clientTop !== undefined ? ({
                  clientLeft: clientLeft,
                  clientTop: clientTop
                }) : undefined,
            element: element
          }
        };
}

function getClassNames(element) {
  var classNames = [];
  element.classList.forEach(function (className, _index) {
        classNames.push(className);
        
      });
  return classNames;
}

function getAttributeNameValuePairs(element) {
  return $$Array.map((function (attribute) {
                return [
                        attribute.name,
                        attribute.value
                      ];
              }), Array.prototype.slice.call(element.attributes));
}

var ElementHelpers = {
  getClassNames: getClassNames,
  getAttributeNameValuePairs: getAttributeNameValuePairs
};

function forDomElementAndItsAncestors(maybeUntilExclusiveAncestor, element) {
  var tagName = element.tagName;
  switch (tagName) {
    case "" :
    case "HTML" :
    case "undefined" :
        return /* [] */0;
    default:
      var node = makeNode(element.id, tagName, getClassNames(element), getAttributeNameValuePairs(element), element.innerText, element.clientLeft, element.clientTop, element.clientWidth, element.clientHeight, element);
      var match = element.parentNode;
      var parentNode;
      if (match == null) {
        return {
                hd: node,
                tl: /* [] */0
              };
      }
      if (maybeUntilExclusiveAncestor !== undefined) {
        if (Caml_obj.caml_equal(match, Caml_option.valFromOption(maybeUntilExclusiveAncestor))) {
          return {
                  hd: node,
                  tl: /* [] */0
                };
        }
        parentNode = match;
      } else {
        parentNode = match;
      }
      var match$1 = Webapi__Dom__Node.nodeType(parentNode);
      if (match$1 !== 10) {
        var parentElement = Webapi__Dom__Element.ofNode(parentNode);
        if (parentElement !== undefined) {
          return {
                  hd: node,
                  tl: forDomElementAndItsAncestors(undefined, Caml_option.valFromOption(parentElement))
                };
        } else {
          console.warn("Expected host node of shadow root to be an element", parentNode);
          return {
                  hd: node,
                  tl: /* [] */0
                };
        }
      }
      var shadowRoot = {
        TAG: /* DocumentFragmentNode */0,
        _0: parentNode
      };
      var hostElement = Webapi__Dom__Element.ofNode(parentNode.host);
      if (hostElement !== undefined) {
        return {
                hd: node,
                tl: {
                  hd: shadowRoot,
                  tl: forDomElementAndItsAncestors(undefined, Caml_option.valFromOption(hostElement))
                }
              };
      } else {
        console.warn("Expected host node of shadow root to be an element", parentNode.host);
        return {
                hd: node,
                tl: {
                  hd: shadowRoot,
                  tl: /* [] */0
                }
              };
      }
  }
}

exports.InnerText = InnerText;
exports.makeNode = makeNode;
exports.ElementHelpers = ElementHelpers;
exports.forDomElementAndItsAncestors = forDomElementAndItsAncestors;
/* Webapi__Dom__Node Not a pure module */
